function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ThemeProvider as BaseProvider } from 'styled-components';
import { baseTheme } from "../base/baseTheme";
import { jsx as _jsx } from "react/jsx-runtime";

/**
 * Theme provider of the flare design system, it takes a flare theme and its mode
 * @param {Theme} theme a theme from the Flare Design System
 * @param {string} mode light or dark
 * @param {string} legacyProduct used to support the legacy theme system.
 * @param {boolean} modeOverwrittenByProduct TRUE when for override mode prop,
 *  - If legacyProduct: nvio, alpha o dark we override mode='dark', rest mode='light'
 * @returns {JSX.Element}
 * @see [Documentation](https://zeroheight.com/85877f0ae/p/98e335-code/t/813a06)
 */
export default (function (_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? baseTheme : _ref$theme,
      _ref$mode = _ref.mode,
      modeProp = _ref$mode === void 0 ? 'light' : _ref$mode,
      _ref$legacyProduct = _ref.legacyProduct,
      legacyProduct = _ref$legacyProduct === void 0 ? 'light' : _ref$legacyProduct,
      _ref$modeOverwrittenB = _ref.modeOverwrittenByProduct,
      modeOverwrittenByProduct = _ref$modeOverwrittenB === void 0 ? false : _ref$modeOverwrittenB,
      children = _ref.children;
  var mode = modeOverwrittenByProduct ? ['nvio', 'alpha', 'dark'].includes(legacyProduct) ? 'dark' : 'light' : modeProp;
  return /*#__PURE__*/_jsx(BaseProvider, {
    theme: _objectSpread(_objectSpread({}, theme[mode]), {}, {
      invertedColors: theme[mode == 'dark' ? 'light' : 'dark'].colors,
      product: legacyProduct
    }),
    children: children
  });
});